module.exports = __webpack_public_path__ + "08e87b76dcdaf5dcccd868c2b6ceacae.svg";